export const cookieAcknowledgmentId = 'cookieAcknowledgmentId'
export const pricingPlansClass = 'pricingPlansClass'
